import { DateRange } from '../types';

/**
 * Type guard to check if a value is a valid DateRange.
 * A DateRange is a tuple with exactly 2 string elements.
 *
 * @param value - The value to check
 * @returns `true` if the value is a DateRange, `false` otherwise
 *
 * @example
 * ```typescript
 * isDateRange(['2023-01-01', '2023-12-31']); // true
 * isDateRange(['', '']); // true
 * isDateRange(['2023-01-01']); // false
 * isDateRange(['2023-01-01', '2023-12-31', '2024-01-01']); // false
 * isDateRange(null); // false
 * isDateRange(undefined); // false
 * isDateRange('string'); // false
 * isDateRange(123); // false
 * ```
 */
export const isDateRange = (value: unknown): value is DateRange => {
  return Array.isArray(value) && value.length === 2 && typeof value[0] === 'string' && typeof value[1] === 'string';
};
